import { AgencyModel } from '@urbanx/agx.agencies.client';
import { createContext, Dispatch, SetStateAction } from 'react';

const agencyContext = createContext<
  [AgencyModel | undefined, Dispatch<SetStateAction<AgencyModel | undefined>>]
>([undefined, () => undefined]);

export default agencyContext;
